import React, { Component } from "react";
import "./courseOverview.css";

import { Container, Row, Col, Card } from "reactstrap";

class CourseOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div>
        <section className="course-intro">
          <Container>
            <Row>
              <Col lg={{size:10, offset:1}} className="course-teaser left-align mt-5">
                <h1>{this.props.teaser}</h1>
              </Col>
            </Row>
            <Row className="course-intro-container">
              <Col sm={{size: 6}} lg={{ size: 6, offset:1}}>
                <Card className="clear-card">
                  <Row className='justify-content-start'>
                    <Col sm={{ size: "auto" }}>
                      <p className="course-time">{this.props.time}</p>
                    </Col>
                    <Col
                      sm={{ size: "auto" }}
                      className="d-none d-sm-block px-0"
                    >
                      <p className="course-time slash"> | </p>
                    </Col>
                    <Col sm={{ size: "auto" }}>
                      <p className="course-time">
                        {" "}
                        {this.props.weeks} | {this.props.hours}
                      </p>
                    </Col>
                  </Row>
                  <p  className="left-align" >{this.props.overview}</p>
                </Card>
              </Col>

              <Col
                lg={{ size: 4}}
                sm={{ size: 6 }}
                className="d-none d-sm-block"
              >
                {this.props.children}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    );
  }
}

export default CourseOverview;
